import UploadAPI from "../Upload.API";

import Func from "../Func";
import {
  // GetReportByGroup,
  GetValueChangeEmployment,
  GetValueChangePositionChange,
  GetValueChangeIdentification,
  GetValueChangeUserGroup,
  GetValueChangeUserCountriesAccess,
  GetValueChangeUserSalesOfficeAccess,
  GetValueChangeReportCountries,
  GetValueChangeUserReportsAccess,
  GetValueChangeUserGroupReportsAccess,
  CheckedRequired,
  GetDepartmentsAfterChanged,
  GetDivisionsAfterChanged,
} from "../../components/infos/events";

const handleEvents = {
  openRehireModal: null, // Will be set later
  closeRehireModal: null, // Will be set later
  setRehireModalRef(ref) {
    console.log("Setting Modal Ref");

    handleEvents.openRehireModal = () => {
      if (ref.current) {
        console.log("Triggering openRehireModal");
        requestAnimationFrame(() => ref.current.openModal()); // ✅ Prevents excessive UI updates
      }
    };

    handleEvents.closeRehireModal = () => {
      if (ref.current) {
        console.log("Triggering closeRehireModal");
        requestAnimationFrame(() => ref.current.closeModal()); // ✅ Prevents excessive UI updates
      }
    };
  },

  setContextFunctions(context) {
    this.getContext = () => context; // Allows access to context values when needed
  },

  OnReactivate: async () => {
    // ✅ Change to arrow function
    const context = handleEvents.getContext(); // ✅ Get context
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const {
      filters,
      storeFilters,
      isReactivated,
      storeReactivate,
      saveData,
      storeSaveData,
    } = context; // ✅ Get values from context
    storeReactivate(true);
    storeFilters({ ...filters, active: "Y" });
    storeSaveData({ ...saveData, active: "Y" });
    console.log("Employee reactivated:", isReactivated);
  },

  processSaveFlow: async ({
    context,
    skipStoreFilterInProcess = false,
    skipUpload = false,
  }) => {
    if (!context) {
      console.error("Context is undefined");
      return;
    }

    const {
      filters,
      filterData,
      storeFilterData,
      storeInfos,
      storeFilters,
      storeSaveData,
      saveData,
      infos,
      isReactivated,
      storeReactivate,
    } = context;

    if (!filters || !storeFilterData || !storeSaveData || !saveData) {
      console.error("Context data missing");
      return;
    }

    const checked = CheckedRequired(filters);
    if (!checked) {
      console.log("checked requires=>" + checked);
      return;
    }

    if (Object.keys(saveData).length === 0) {
      return;
    }

    if (!skipStoreFilterInProcess) {
      storeFilterData({ ...filterData, status: "inprocess" });
    }

    if (isReactivated) {
      const email = filters?.email ? filters?.email : "";
      if (email.toLowerCase().includes("old")) {
        storeFilterData({
          ...filterData,
          key_form: Math.random(),
          status: "error save user",
          message: `Sorry, The email should not to contains 'old'.`,
        });
        return;
      }
      saveData.email = email;
    }

    if (skipUpload) {
      // For OnNext, skip upload and update only
      window.history.replaceState(
        {},
        "",
        `/employees/profile?tab=personaldata&isnext=1`
      );
      storeInfos({
        ...infos,
        // keyChange: Func.GetKeyRandom(),
      });
      return;
    }

    // Proceed with upload logic
    const payloadSaveData = { ...saveData };
    if (Array.isArray(payloadSaveData.identification)) {
      payloadSaveData.identification = payloadSaveData.identification.map(
        (item) => ({
          ...item,
          id: item?.id ?? null,
        })
      );
    }

    let formData = new FormData();
    formData.append("userID", window.$user_profile.idu);
    formData.append("userEmail", window.$user_profile.emailadd);
    formData.append("staffID", filters?.idu ?? 0);

    const files = payloadSaveData?.photo ?? [];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append("photo[]", files[i], files[i]["name"]);
      }
      delete payloadSaveData.photo;
    }

    formData.append("saveData", JSON.stringify(payloadSaveData));

    try {
      const res = await UploadAPI.post("info/user/save", formData);
      storeFilterData({ ...filterData, status: "success" });

      const decrypt = (res?.data);
      // console.log("decrypt=", decrypt);
      if (decrypt?.status === "success" && decrypt?.data) {
        if (decrypt?.data?.staffID && decrypt?.data?.isNew) {
          window.history.replaceState(
            {},
            "",
            `/employees/profile?tab=personaldata&id=${decrypt.data.staffID}`
          );
          storeInfos({
            ...infos,
            staff_id: decrypt.data.staffID,
            isNext: 0,
          });
        } else {
          storeInfos({
            ...infos,
            keyChange: Func.GetKeyRandom(),
            isNext: 0,
          });
        }

        storeSaveData({}, true);
        storeReactivate(false);
        storeFilters({
          ...decrypt.data?.staffDetail,
          key_form: Math.random(),
          type: "saveUser",
        });
      } else {
        storeFilterData({
          ...filterData,
          status: "error save user",
          message: decrypt?.err_msg ?? "Fail",
        });
      }
    } catch (err) {
      storeFilterData({
        ...filterData,
        status: "error save user",
        message: `${err}`,
      });
    }
  },

  OnNext: async () => {
    const context = handleEvents.getContext();
    await handleEvents.processSaveFlow({
      context,
      skipStoreFilterInProcess: true,
      skipUpload: true,
    });
  },

  OnSave: async () => {
    const context = handleEvents.getContext();
    await handleEvents.processSaveFlow({
      context,
    });
  },

  OnSelectChange: (evt, { id, name, value }) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnSelectChange");
      return;
    }

    const {
      filters,
      filterData,
      storeFilters,
      storeSaveData,
      saveData,
      storeReactivate,
    } = context;

    let saveValue;
    const tmp = { ...filters };

    if (["employment_type"].includes(name)) {
      [name, value] = GetValueChangeEmployment(id, name, value, tmp);
    } else if (["position_change_reason"].includes(name)) {
      [name, value] = GetValueChangePositionChange(id, name, value, tmp);
    } else if (["identification_type"].includes(name)) {
      [name, value] = GetValueChangeIdentification(id, name, value, tmp, {
        name: evt.target?.innerText,
      });
    } else if (name === "country") {
      const countryData = filterData.data.countries.find(
        (item) => item.country_code === value
      );
      saveValue = countryData?.country_name ?? "";
    } else if (name === "work_country") {
      const countryData = filterData.data.workcountries.find(
        (item) => item.country_code === value
      );
      saveValue = countryData?.country_name ?? "";
    } else if (name === "organization") {
      const newDepartment = GetDepartmentsAfterChanged(
        filterData?.data?.departments ?? {},
        value,
        tmp?.department ?? []
      );
      tmp.department = newDepartment;
      saveData.department = newDepartment;

      const newDivision = GetDivisionsAfterChanged(
        filterData?.data?.divisions ?? {},
        newDepartment,
        tmp?.division ?? []
      );
      tmp.division = newDivision;
      saveData.division = newDivision;
    } else if (name === "department") {
      const newDivision = GetDivisionsAfterChanged(
        filterData?.data?.divisions ?? {},
        value,
        tmp?.division ?? []
      );
      tmp.division = newDivision;
      saveData.division = newDivision;
    } else if (name === "active") {
      if (value === "Y" && filters?.current_active === "N") {
        storeReactivate(true);
      } else if (value === "N") {
        storeReactivate(false);
        tmp.email = filters.current_email;
        saveData.email = filters.current_email;
      }
    }
    value = typeof value === "string" ? value.trim() : value;
    saveValue = typeof saveValue === "string" ? saveValue.trim() : saveValue;
    tmp[name] = value;

    if (["country", "work_country", "identification"].includes(name)) {
      tmp.key_form = Math.random();
    }

    storeFilters(tmp);

    const tmpSave = { ...saveData };
    if (name === "organization") {
      tmpSave.organization = tmp?.branch ?? [];
      tmpSave.organization = tmpSave.organization.concat(value);
    } else if (name === "branch") {
      tmpSave.organization = tmp?.organization ?? [];
      tmpSave.organization = tmpSave.organization.concat(value);
      tmpSave.branch = saveValue ?? value;
    } else if (name === "department") {
      tmpSave.department = tmp?.division ?? [];
      tmpSave.department = tmpSave.department.concat(value);
    } else if (name === "division") {
      tmpSave.department = tmp?.department ?? [];
      tmpSave.department = tmpSave.department.concat(value);
      tmpSave.division = saveValue ?? value;
    } else if (name === "job_class") {
      tmpSave.job_class = value;
      tmpSave.job_class_name = evt.target.innerText;
    } else if (name === "job_type") {
      tmpSave.job_type = value;
      tmpSave.job_type_name = evt.target.innerText;
    } else if (name === "contact_country_code") {
      const countryData = filterData.data.workcountries.find(
        (item) => item.country_code === value
      );
      tmpSave["contact_country"] = countryData?.country_name ?? "";
    } else {
      tmpSave[name] = saveValue ?? value;
    }
    // console.log({ tmp: tmp, tmpSave: tmpSave });
    storeSaveData(tmpSave);
  },

  OnChange: (evt) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnSelectChange");
      return;
    }

    const { filters, filterData, storeFilters, storeSaveData, saveData } =
      context;

    // console.log(evt);//return;
    let name = evt.target.name;
    let value = evt.target.value;
    // console.log("name=", name, value, evt.target.id);
    let saveValue;
    const tmp = { ...filters };
    if (["start_date", "end_date"].includes(name)) {
      [name, value] = GetValueChangeEmployment(evt.target.id, name, value, tmp);
    } else if (
      [
        "position_change_job_title",
        "position_change_start_date",
        "position_change_end_date",
      ].includes(name)
    ) {
      [name, value] = GetValueChangePositionChange(
        evt.target.id,
        name,
        value,
        tmp
      );
    } else if (
      [
        "identification_name",
        "identification_number",
        "identification_expiration_date",
        "identification_description",
        "identification_link",
      ].includes(name)
    ) {
      [name, value] = GetValueChangeIdentification(
        evt.target.id,
        name,
        value,
        tmp
      );
    } else if (name === "user_group") {
      [name, value] = GetValueChangeUserGroup(evt, tmp);
    } else if (name === "user_countries_access") {
      //[name, value] = GetValueChangeUserCountriesAccess(evt, tmp);
      [name, value] = GetValueChangeUserCountriesAccess({
        checked: evt.target.checked,
        value: value,
        filters: tmp,
      });
    } else if (name === "user_sales_office_access") {
      [name, value] = GetValueChangeUserSalesOfficeAccess(evt, tmp);
    } else if (name === "report_countries") {
      [name, value] = GetValueChangeReportCountries(evt, tmp);
    } else if (name === "user_reports_access") {
      [name, value] = GetValueChangeUserReportsAccess({
        checked: evt.target.checked,
        value: value,
        filters: tmp,
      });
    } else if (name === "user_group_reports_access") {
      [name, value] = GetValueChangeUserGroupReportsAccess({
        checked: evt.target.checked,
        value: value,
        filters: tmp,
        filterData: filterData,
      });
    } else if (name === "photo") {
      const fileList = evt.target.files;
      const maxSizeInBytes = 2 * 1024 * 1024 * 1024; // 2 GB in bytes
      let files = [];
      if (fileList) {
        const n = fileList.length;
        for (let i = 0; i < n; i++) {
          // console.log(
          //   fileList[i].size,
          //   maxSizeInBytes,
          //   "type=",
          //   fileList[i].type
          // );
          if (fileList[i].size > maxSizeInBytes) {
            alert("File size exceeds 2GB. Please select a smaller file.");
            return;
          }
          fileList[i].data_url = URL.createObjectURL(fileList[i]);
        }
        files = [...fileList];
      }
      value = [...files];
    } else if (name === "email") {
      value = value.toLowerCase().replace(/\s+/g, "");
    }
    value = typeof value === "string" ? value : value;
    saveValue = typeof saveValue === "string" ? saveValue : saveValue;
    tmp[name] = value;
    storeFilters(tmp);
    // console.log("On change=", tmp);
    const tmpSave = { ...saveData };
    tmpSave[name] = saveValue ?? value;
    storeSaveData(tmpSave);
  },
  BtnAddEmployment: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters } = context;

      storeFilters({
        ...filters,
        employment: [
          ...filters.employment,
          { employment_type: "", start_date: "", end_date: "" },
        ],
      });
    },
  },
  BtnDeleteEmployment: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters, saveData, storeSaveData } = context;

      const index = parseInt(evt.target.parentElement.getAttribute("index"));
      let temp = [...filters.employment];
      if (temp.length <= 1) {
        temp = [{ employment_type: "", start_date: "", end_date: "" }];
      } else {
        temp.splice(index, 1);
      }
      storeFilters({
        ...filters,
        employment: temp,
      });
      storeSaveData({ ...saveData, employment: temp });
    },
  },
  BtnAddPositionChange: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters } = context;

      storeFilters({
        ...filters,
        position_change: [
          ...filters.position_change,
          { position: "", reason: "", start_date: null, end_date: null },
        ],
      });
    },
  },
  BtnDeletePositionChange: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters, saveData, storeSaveData } = context;

      const index = parseInt(evt.target.parentElement.getAttribute("index"));
      let temp = [...filters.position_change];
      if (temp.length <= 1) {
        temp = [{ position: "", reason: "", start_date: null, end_date: null }];
      } else {
        temp.splice(index, 1);
      }
      storeFilters({
        ...filters,
        position_change: temp,
      });
      storeSaveData({ ...saveData, position_change: temp });
    },
  },
  BtnAddIdentification: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters } = context;

      storeFilters({
        ...filters,
        identification: [
          ...filters.identification,
          {
            id: null,
            type: "",
            name: "",
            number: "",
            expiration_date: "",
            description: "",
            link: "",
            updated_date: null,
          },
        ],
      });
    },
  },
  BtnDeleteIdentification: {
    OnClick: (evt) => {
      const context = handleEvents.getContext();
      if (!context) {
        console.error("Context is undefined in handleEvents.OnClick");
        return;
      }
      const { filters, storeFilters, saveData, storeSaveData } = context;

      const index = parseInt(evt.target.parentElement.getAttribute("index"));
      let temp = [...filters.identification];
      temp.splice(index, 1);
      storeFilters({
        ...filters,
        identification: temp,
      });
      storeSaveData({ ...saveData, identification: temp });
    },
  },
};

export default handleEvents;

